import * as React from "react";

export function Tabs({ defaultValue, children, className = "" }) {
  const [value, setValue] = React.useState(defaultValue);
  return (
    <div className={className}>
      {React.Children.map(children, (child) =>
        React.cloneElement(child, { value, setValue })
      )}
    </div>
  );
}

export function TabsList({ children, className = "", value, setValue }) {
  return (
    <div
      className={`flex gap-2 bg-slate-100 p-1 rounded-xl ${className}`}
    >
      {React.Children.map(children, (child) =>
        React.isValidElement(child) ? React.cloneElement(child, { value, setValue }) : child
      )}
    </div>
  );
}

export function TabsTrigger({ value: tabValue, value, setValue, children }) {
  const active = value === tabValue;
  return (
    <button
      onClick={() => setValue(tabValue)}
      className={`px-4 py-2 rounded-lg text-sm font-medium transition 
        ${active ? "bg-white shadow text-slate-900" : "text-slate-500"}
      `}
    >
      {children}
    </button>
  );
}
